<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/polar';
import 'zrender/lib/svg/svg'
export default {
    name:"char3",
    components:{
         'v-chart': ECharts
    },
    props:{
        data:Object,
        datelist:{
            type:Array,
            default:()=>{
              return []
            }
        },
        bwidth:{
            type:Number,
            default:14
        }
    },
    data(){
        return {
            option:{},
             viewdata:{},
      viewdate:[],
        timer:false
        }
    }, 
    watch:{
        datelist:{
            handler(){  
                          
              this.dataInit();
              this.init()
            },
            deep:false
        }
    },
    methods:{
        dataInit(){    
                   
            this.viewdata.data1= this.data.data1.slice(0,5); 
            this.viewdata.data2= this.data.data2.slice(0,5); 
            this.viewdata.data3= this.data.data3.slice(0,5); 
            
            this.viewdate=this.datelist.slice(0,5);    
           this.doit()
        },
        init(){            
           
              this.option={
                grid: {
                    top:'20%',
                    left: '5%',
                    right: '5%',
                    bottom:'12%',
                    containLabel: true
                },
                legend: {
                    bottom:'4%',
                    itemWidth:6,
                    itemHeight:6,
                    textStyle:{
                        color:"#fff",                       
                    },
                    icon:"rect",
                    data: ['平均停留时长', '停留客流数','热力值']
                },
                tooltip:{
                     position:['50%', '50%'],
                    formatter: function(params,index) {    
                    　　var result = params[0].name+'</br>'
                    　　params.forEach(function (item) {  
                            
                            if(item.seriesId=="a1"){ 
                                result += item.seriesName +":"+ item.data + "%</br>"
                            }else if(item.seriesId=="a2"){ //活跃会员数                            
                                if(item.data>10000){
                              　    result += item.seriesName +":"+ (item.data/10000) + "万</br>"
                                }
                                else{                                
                                  　result += item.seriesName +":"+ item.data + "</br>"
                                }
                            }else if(item.seriesId=="a3"){ //活跃会员数                            
                                result += item.seriesName +":"+ item.data + "%</br>"
                            }                            
                            else{
                              result += item.seriesName +":"+ item.data + "</br>"
                            }                          
                           
                    　　})                   
                    　　return result                
                    },
                    textStyle:{
                        fontSize:14
                    },
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",      
                        shadowStyle:{
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 1, color: 'rgba(246, 232, 87,0)' // 0% 处的颜色
                                }, {
                                    offset: 0, color: 'rgba(234, 205, 44,0.4)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        }  
                    },
                    // position:["50%","50%"]
                },                
                xAxis: {
                    
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'solid',
                            width:1,
                        },
                        minInterval:0
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                    type: 'category',                              
                    data: this.viewdate,
                },
                yAxis: [{
                     name:"平均停留时长",
                       offset:80,
                    position:"left",
                    nameRotate:320,
                    nameTextStyle:{
                        color:"#fff"
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                {
                      offset:40,
                    position:"left",
                     name:"停留客流数",
                    nameRotate:320,
                    nameTextStyle:{
                        color:"#fff"
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                },
                {
                   
                     position:"left",
                     name:"热力值",
                    nameRotate:320,
                    nameTextStyle:{
                        color:"#fff"
                    },
                    axisLabel: {             
                      color:'#fff'
                    },
                     splitLine: {
                        show: true,
                        lineStyle: {
                            color: '#323645',
                            type: 'dashed',
                            width:1,
                        },
                        minInterval:0
                    },
                    type: 'value'
                }
                ],
                series: [{
                    id:'a1',
                    name:"平均停留时长",
                    data: this.viewdata.data1,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#2d99ff"
                        },                  
                    },
                    barWidth:this.barWidth,
                    
                },
                {
                    id:'a2',
                     name:"停留客流数",
                    data: this.viewdata.data2,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#8943d3"
                        },                  
                    },
                    barWidth:this.barWidth,
                     yAxisIndex:'1',      
                },
                {
                    id:'a3',
                    name:"热力值",
                    data: this.viewdata.data3,
                    type: 'bar',
                    itemStyle:{
                        normal:{ 
                            color:"#43d3c9"
                        },                  
                    },
                    barWidth:this.barWidth,
                    yAxisIndex:'2',   
                }]
            }                        
           setTimeout(()=>{
                  
                this.$nextTick(()=>{
                    this.$refs.my.dispatchAction({
                        type: 'showTip',         
                        seriesIndex: 0,
                        dataIndex: 2                     
                    })
                })
            },500) 
            // this.doit()
           
        },
        rundata(){
            this.datelist.push(this.datelist.shift())
            this.data.data1.push(this.data.data1.shift())
            this.data.data2.push(this.data.data2.shift())
            this.data.data3.push(this.data.data3.shift())
           
        },
        //动画
        doit(){    
        let that=this
            if(this.timer){
                window.clearTimeout(that.timer);
            }
            this.timer= setTimeout(()=>{                             
                that.rundata()
            },3000)      
        },
    },
    mounted(){
        //   this.init()
    }
}
</script>